import { parse, format } from "date-fns";

export const toDate = (v?: string) =>
  v ? parse(v, "yyyy-MM-dd", new Date()) : undefined;

export const toStr = (d?: Date | null) => (d ? format(d, "yyyy-MM-dd") : "");
